import {
	SystemBGEvent,
	SystemBPEvent,
	SystemStepEvent,
	SystemWeightEvent,
} from './systemEvent'
import { PatientCarePlan, PatientScreeningTags } from './patients'
import { PatientRecentAlertsState } from './patientRecentAlerts'

export interface ClinicalState {
	metabolicStat: ClinicalMetabolicStatState
	msk: ClinicalMSKState
	recentAlerts: PatientRecentAlertsState
}

export interface ClinicalMetabolicStatState {
	bgEvents: Array<SystemBGEvent>
	bpEvents: Array<SystemBPEvent>
	weightEvents: Array<SystemWeightEvent>
	pedometerEvents: Array<SystemStepEvent>
}

export interface ClinicalMSKState {
	carePlan: PatientCarePlan | null
	screeningTags: PatientScreeningTags | null
}

export enum CLINICAL_MSK_ACTION_TYPES {
	GET_PATIENT_DATA = 'MSK_GET_PATIENT_DATA',
}

export interface ClinicalMSKGetPatientData {
	type: CLINICAL_MSK_ACTION_TYPES.GET_PATIENT_DATA
	payload: {
		carePlan: PatientCarePlan
		screeningTags: PatientScreeningTags
	}
}

export enum CLINICAL_METABOLIC_STAT_ACTION_TYPES {
	GET_BG_EVENTS = 'METABOLIC_STAT_BG_EVENTS_GET',
	GET_BP_EVENTS = 'METABOLIC_STAT_BP_EVENTS_GET',
	GET_WEIGHT_EVENTS = 'METABOLIC_STAT_WEIGHT_EVENTS_GET',
	GET_PEDOMETER_EVENTS = 'METABOLIC_STAT_PEDOMETER_EVENTS_GET',
}

export interface ClinicalMetabolicStatGetBG {
	type: CLINICAL_METABOLIC_STAT_ACTION_TYPES.GET_BG_EVENTS
	payload: Array<SystemBGEvent>
}

export interface ClinicalMetabolicStatGetBP {
	type: CLINICAL_METABOLIC_STAT_ACTION_TYPES.GET_BP_EVENTS
	payload: Array<SystemBPEvent>
}

export interface ClinicalMetabolicStatGetWeight {
	type: CLINICAL_METABOLIC_STAT_ACTION_TYPES.GET_WEIGHT_EVENTS
	payload: Array<SystemWeightEvent>
}

export interface ClinicalMetabolicStatGetPedometer {
	type: CLINICAL_METABOLIC_STAT_ACTION_TYPES.GET_PEDOMETER_EVENTS
	payload: Array<SystemStepEvent>
}

export type ClinicalMetabolicStatAction =
	| ClinicalMetabolicStatGetBP
	| ClinicalMetabolicStatGetBG
	| ClinicalMetabolicStatGetWeight
	| ClinicalMetabolicStatGetPedometer

export type ClinicalMSKAction = ClinicalMSKGetPatientData
